import { useEffect, useState } from "react";
import "./restaurant-menu-view.styles.scss";
import { useContext } from "react";
import { MenuContext } from "../../../../contexts/menu.context";
import RMItem from "../restaurant-menu-item/restaurant-menu-item.component";
const RMView = () => {
  const [menu, setMenu] = useState({});
  const { menuContext, searchTerm } = useContext(MenuContext);

  useEffect(() => {
    if (menuContext) {
      setMenu(menuContext);
    }
  }, [menuContext]);
  return (
    <div className="rmview-container">
      {Object.keys(menu).length > 0 ? (
        <div>
          {Object.keys(menu).map((index) => {
            if (index !== "metadata" && index !== "hotelID") {
              return (
                <RMItem key={index} menuItem={menu[index]} itemName={index} />
              );
            }
          })}
        </div>
      ) : (
        <div className="rmview-nomenu-message">
          You haven't added a menu, add categories and menu items
        </div>
      )}
    </div>
  );
};
export default RMView;
